/**
 * AuthLayout Component
 *
 * Centered layout with logo for auth pages.
 */

import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

interface AuthLayoutProps {
    title: string;
    subtitle?: string;
    children: ReactNode;
    footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
    return (
        <div className="flex min-h-screen items-center justify-center bg-neutral-950 p-4 selection:bg-emerald-500 selection:text-black sm:p-6">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full max-w-lg"
            >
                <div className="overflow-hidden rounded-3xl border border-neutral-800 bg-neutral-900 p-8 shadow-2xl sm:p-12">
                    {/* Header */}
                    <div className="mb-10 text-center">
                        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-emerald-500/20 bg-emerald-500/10 shadow-2xl shadow-emerald-500/5">
                            <img
                                src="/sisumail_logo.webp"
                                alt="Logo"
                                className="h-10 w-10 rounded-lg"
                            />
                        </div>
                        <h1 className="mb-2 font-bold text-3xl text-white tracking-tight">
                            {title}
                        </h1>
                        {subtitle && <p className="font-medium text-neutral-500">{subtitle}</p>}
                    </div>

                    {children}

                    {/* Footer */}
                    {footer && (
                        <div className="mt-8 border-neutral-800 border-t pt-8 text-center font-bold text-[10px] uppercase tracking-widest">
                            {footer}
                        </div>
                    )}
                </div>

                <p className="mt-8 text-center font-bold text-[10px] text-neutral-700 uppercase tracking-[0.2em]">
                    Honest Privacy • Encrypted in Finland
                </p>
            </motion.div>
        </div>
    );
}
